import { UNLIMITED_VALUE } from "@search/store/constants";
import pluralize from "pluralize";

function customPluralize(
  word: string,
  count: number,
  inclusive: boolean = false,
): string {
  if (count === UNLIMITED_VALUE) {
    return `Unlimited ${pluralize(word, count, false)}`;
  }

  return pluralize(word, count, inclusive);
}

export { customPluralize };
